/* MYNTELO shoppable Instagram feed (2026-10-20): the theme's own replacement for the Vitals Shoppable Instagram Feed.
   Posts come from the Supabase edge function "ig-feed" (Instagram API with Instagram Login, cached 30 min).
   Better than the app: products tag themselves from the design name in the caption ("ASTRA" -> the Astra iPhone case,
   Galaxy case, wallet and grip), the pop-up sells (price, Add to bag for one-option products, Choose model for cases),
   reels play inline, and on a product page the posts of that design come first. */
(function () {
  'use strict';
  var root = document.querySelector('[data-m-ig]');
  var cfgEl = document.querySelector('[data-m-ig-config]');
  if (!root || !cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (_) { return; }
  var grid = root.querySelector('[data-m-ig-grid]');
  var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var mobileMQ = window.matchMedia('(max-width: 749px)');
  var feed = null, posts = [], profile = null, modal = null, cur = -1, slide = 0, lastFocus = null;

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML.replace(/"/g, '&quot;'); }
  function num(n) { if (n == null) return ''; if (n >= 1e6) return (n / 1e6).toFixed(1).replace(/\.0$/, '') + 'M'; if (n >= 1e4) return Math.round(n / 1e3) + 'K'; if (n >= 1e3) return (n / 1e3).toFixed(1).replace(/\.0$/, '') + 'K'; return String(n); }
  function money(cents) {
    var f = window.moneyFormat || '${{amount}}', v = (cents || 0) / 100;
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k.indexOf('no_decimals') > -1) v = Math.round(v);
      var s = k.indexOf('no_decimals') > -1 ? String(v) : v.toFixed(2);
      var parts = s.split('.'), sep = k.indexOf('comma_separator') > -1 ? '.' : ',', dec = k.indexOf('comma_separator') > -1 ? ',' : '.';
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return parts.join(dec);
    }).replace(/<[^>]*>/g, '');
  }
  function sized(src, w) { if (!src) return ''; src = String(src); if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
  function date(iso) { try { return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }); } catch (_) { return ''; } }

  /* Design names from the catalogue (Liquid) matched as whole words in the caption, longest first ("Veridis Quo" before "Quo"). */
  var designs = (cfg.designs || []).slice().sort(function (a, b) { return b.n.length - a.n.length; })
    .map(function (d) { return { n: d.n, s: d.s, re: new RegExp('(^|[^a-z])' + d.n.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '[\\s_-]*') + '(?![a-z])', 'i') }; });
  function designsIn(caption) {
    var out = [], text = String(caption || '');
    designs.forEach(function (d) { if (d.re.test(text) && out.indexOf(d.s) < 0) out.push(d.s); });
    return out;
  }
  var KINDS = ['-magsafe-tough-phone-case', '-galaxy-tough-case', '-magnetic-wallet', '-magnetic-grip'];
  var productCache = {};
  function product(handle) {
    if (!productCache[handle]) productCache[handle] = fetch(shopRoot + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return productCache[handle];
  }
  function productsFor(post) {
    var slugs = designsIn(post.caption).slice(0, 2), handles = [];
    /* 2026-10-23 Monarch rename: the Lucent design is now Monarch; wallet/grip may keep lucent-* handles, so both slugs are tried and duplicates (301s) dropped by id */
    slugs.forEach(function (s) { var alias = s === 'monarch' ? 'lucent' : s === 'lucent' ? 'monarch' : ''; KINDS.forEach(function (k) { handles.push(s + k); if (alias) handles.push(alias + k); }); });
    return Promise.all(handles.map(product)).then(function (list) { var seen = {}; return list.filter(function (p) { if (!p || p.available === false || seen[p.id]) return false; seen[p.id] = 1; return true; }).slice(0, cfg.maxProducts || 4); });
  }

  /* Grid ---------------------------------------------------------------------------------------- */
  function layout() { return mobileMQ.matches ? cfg.mobile : cfg.desktop; }
  function icon(name) {
    var p = {
      ig: '<path d="M12 7.3A4.7 4.7 0 1 0 16.7 12 4.7 4.7 0 0 0 12 7.3Zm0 7.7a3 3 0 1 1 3-3 3 3 0 0 1-3 3Zm6-7.9a1.1 1.1 0 1 1-1.1-1.1A1.1 1.1 0 0 1 18 7.1ZM21.1 8.2A5.4 5.4 0 0 0 19.6 4.4 5.4 5.4 0 0 0 15.8 2.9C14.3 2.8 9.7 2.8 8.2 2.9A5.4 5.4 0 0 0 4.4 4.4 5.4 5.4 0 0 0 2.9 8.2c-.1 1.5-.1 6.1 0 7.6a5.4 5.4 0 0 0 1.5 3.8 5.4 5.4 0 0 0 3.8 1.5c1.5.1 6.1.1 7.6 0a5.4 5.4 0 0 0 3.8-1.5 5.4 5.4 0 0 0 1.5-3.8c.1-1.5.1-6.1 0-7.6Z"/>',
      heart: '<path d="M12 21s-7.5-4.6-9.6-9.3C.9 8.3 3 4.5 6.7 4.5c2 0 3.5 1.1 4.3 2.5.8-1.4 2.3-2.5 4.3-2.5 3.7 0 5.8 3.8 4.3 7.2C19.5 16.4 12 21 12 21Z"/>',
      comment: '<path d="M21 11.5a8.4 8.4 0 0 1-12.4 7.4L3 20.5l1.6-5.3A8.4 8.4 0 1 1 21 11.5Z"/>',
      reel: '<path d="M8 5v14l11-7Z"/>',
      album: '<path d="M7 3h11a3 3 0 0 1 3 3v11h-2V6a1 1 0 0 0-1-1H7Zm-3 4h11a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z"/>'
    }[name];
    return '<svg class="m-ig__i m-ig__i--' + name + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + p + '</svg>';
  }

  // SEO 2026-11-03: alt text for feed images from the post caption (hashtags, handles, emoji and letter-spaced words cleaned,
  // 110 chars), else a plain label.
  function altOf(p) {
    var c = String((p && p.caption) || '').replace(/#[^\s#]+/g, '').replace(/@[^\s@]+/g, '')
      .replace(/[\u2190-\u2BFF\uFE0F\u200D]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g, ' ')
      .replace(/\b(?:[A-Za-z] ){1,}[A-Za-z]\b/g, function (m) { return m.replace(/ /g, ''); })
      .replace(/\s+/g, ' ').trim();
    if (c.length > 110) c = c.slice(0, 107).replace(/\s+\S*$/, '') + '...';
    return c ? 'MYNTELO on Instagram: ' + c : 'MYNTELO on Instagram: designer art phone case post';
  }
  function render() {
    var L = layout(), max = L.layout === 'slider' ? (cfg.sliderCount || 12) : L.cols * L.rows;
    root.dataset.layout = L.layout;
    root.style.setProperty('--m-ig-cols', L.cols);
    grid.innerHTML = posts.slice(0, max).map(function (p, i) {
      var img = p.thumb || p.url || (p.children[0] && (p.children[0].thumb || p.children[0].url));
      var badge = p.type === 'VIDEO' ? icon('reel') : p.type === 'CAROUSEL_ALBUM' ? icon('album') : '';
      var counts = cfg.showCounts && (p.likes != null || p.comments != null)
        ? '<span class="m-ig__counts">' + (p.likes != null ? '<span>' + icon('heart') + num(p.likes) + '</span>' : '') + (p.comments != null ? '<span>' + icon('comment') + num(p.comments) + '</span>' : '') + '</span>'
        : '<span class="m-ig__counts">' + icon('ig') + '</span>';
      return '<li class="m-ig__item"><button type="button" class="m-ig__tile" data-i="' + i + '" aria-label="Open Instagram post' + (p.caption ? ': ' + esc(p.caption.slice(0, 80)) : '') + '">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(altOf(p)) + '" loading="lazy" decoding="async">' : '') +
        (badge ? '<span class="m-ig__badge">' + badge + '</span>' : '') +
        '<span class="m-ig__hover">' + counts + '</span></button></li>';
    }).join('');
    root.hidden = !posts.length;
  }

  grid.addEventListener('click', function (e) {
    var t = e.target.closest('[data-i]');
    if (t) open(parseInt(t.dataset.i, 10), t);
  });
  // Desktop: a reel plays silently while hovered ("better than the app").
  grid.addEventListener('mouseover', function (e) {
    var t = e.target.closest('[data-i]'); if (!t || mobileMQ.matches || t.querySelector('video')) return;
    var p = posts[t.dataset.i]; if (!p || p.type !== 'VIDEO' || !p.url) return;
    var v = document.createElement('video'); v.src = p.url; v.muted = true; v.loop = true; v.playsInline = true; v.className = 'm-ig__preview';
    t.insertBefore(v, t.firstChild.nextSibling); v.play().catch(function () {});
    t.addEventListener('mouseleave', function off() { t.removeEventListener('mouseleave', off); v.remove(); });
  });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-m-ig-scroll]'); if (!b) return;
    grid.scrollBy({ left: (b.dataset.mIgScroll === 'next' ? 1 : -1) * grid.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* Pop-up -------------------------------------------------------------------------------------- */
  function build() {
    modal = document.createElement('div');
    modal.className = 'm-igm';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Instagram post');
    modal.innerHTML =
      '<div class="m-igm__overlay" data-close></div>' +
      '<button type="button" class="m-igm__nav m-igm__nav--prev" data-step="-1" aria-label="Previous post">&#8249;</button>' +
      '<button type="button" class="m-igm__nav m-igm__nav--next" data-step="1" aria-label="Next post">&#8250;</button>' +
      '<div class="m-igm__panel">' +
        '<button type="button" class="m-igm__close" data-close aria-label="Close">&times;</button>' +
        '<div class="m-igm__media" data-media></div>' +
        '<div class="m-igm__side">' +
          '<header class="m-igm__head" data-head></header>' +
          '<div class="m-igm__body"><p class="m-igm__caption" data-caption></p>' +
          '<div class="m-igm__shop" data-shop></div></div>' +
          '<footer class="m-igm__meta" data-meta></footer>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', onModalClick);
    document.addEventListener('keydown', function (e) {
      if (!modal || modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') step(1);
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'Tab') trap(e);
    });
    var x0 = null;
    modal.querySelector('[data-media]').addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    modal.querySelector('[data-media]').addEventListener('touchend', function (e) {
      if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) < 50) return;
      var p = posts[cur];
      if (p && p.children.length > 1) { var n = slide + (dx < 0 ? 1 : -1); if (n >= 0 && n < p.children.length) { showSlide(n); return; } }
      step(dx < 0 ? 1 : -1);
    }, { passive: true });
  }
  function trap(e) {
    var els = Array.prototype.filter.call(modal.querySelectorAll('a[href], button:not([disabled]), video[controls]'), function (el) { return el.offsetParent !== null; });
    if (!els.length) return;
    var first = els[0], last = els[els.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function mediaHTML(m, active) {
    if (m.type === 'VIDEO' && m.url) return '<video src="' + esc(m.url) + '"' + (m.thumb ? ' poster="' + esc(m.thumb) + '"' : '') + ' playsinline muted loop controls' + (active ? ' autoplay' : '') + ' preload="metadata"></video>';
    var src = m.thumb || m.url;
    return src ? '<img src="' + esc(src) + '" alt="' + esc(altOf(posts[cur])) + '">' : '';
  }
  function showSlide(n) {
    var p = posts[cur], wrap = modal.querySelector('[data-media]');
    slide = n;
    wrap.querySelectorAll('.m-igm__slide').forEach(function (el, i) {
      el.classList.toggle('is-on', i === n);
      var v = el.querySelector('video'); if (v) { if (i === n) v.play().catch(function () {}); else v.pause(); }
    });
    wrap.querySelectorAll('.m-igm__dot').forEach(function (d, i) { d.classList.toggle('is-on', i === n); });
    var prev = wrap.querySelector('[data-slide="-1"]'), next = wrap.querySelector('[data-slide="1"]');
    if (prev) prev.disabled = n === 0;
    if (next) next.disabled = n === p.children.length - 1;
  }
  function fill(i) {
    var p = posts[i]; cur = i; slide = 0;
    var wrap = modal.querySelector('[data-media]');
    if (p.children.length > 1) {
      wrap.innerHTML = p.children.map(function (c, k) { return '<div class="m-igm__slide' + (k === 0 ? ' is-on' : '') + '">' + mediaHTML(c, k === 0) + '</div>'; }).join('') +
        '<button type="button" class="m-igm__arrow m-igm__arrow--prev" data-slide="-1" aria-label="Previous slide">&#8249;</button>' +
        '<button type="button" class="m-igm__arrow m-igm__arrow--next" data-slide="1" aria-label="Next slide">&#8250;</button>' +
        '<div class="m-igm__dots">' + p.children.map(function (c, k) { return '<span class="m-igm__dot' + (k === 0 ? ' is-on' : '') + '"></span>'; }).join('') + '</div>';
      showSlide(0);
    } else if (p.type === 'VIDEO' && !p.url) {
      wrap.innerHTML = '<a class="m-igm__watch" href="' + esc(p.link) + '" target="_blank" rel="noopener">' + (p.thumb ? '<img src="' + esc(p.thumb) + '" alt="' + esc(altOf(p)) + '">' : '') + '<span>' + icon('reel') + 'Watch on Instagram</span></a>';
    } else {
      wrap.innerHTML = '<div class="m-igm__slide is-on">' + mediaHTML(p, true) + '</div>';
    }
    var user = profile && profile.username ? profile.username : '';
    modal.querySelector('[data-head]').innerHTML =
      (profile && profile.avatar ? '<img class="m-igm__avatar" src="' + esc(profile.avatar) + '" alt="" role="presentation" width="36" height="36">' : '<span class="m-igm__avatar m-igm__avatar--blank">' + icon('ig') + '</span>') +
      '<a class="m-igm__user" href="' + esc(profile ? profile.link : p.link) + '" target="_blank" rel="noopener">' + esc(user) + '</a>' +
      '<a class="m-igm__follow" href="' + esc(profile ? profile.link : p.link) + '" target="_blank" rel="noopener">' + esc(cfg.followText || 'Follow') + '</a>';
    var cap = modal.querySelector('[data-caption]');
    cap.textContent = p.caption || '';
    cap.classList.remove('is-open');
    cap.hidden = !p.caption;
    modal.querySelector('[data-meta]').innerHTML =
      (cfg.showCounts && p.likes != null ? '<span>' + icon('heart') + num(p.likes) + '</span>' : '') +
      (cfg.showCounts && p.comments != null ? '<span>' + icon('comment') + num(p.comments) + '</span>' : '') +
      '<time datetime="' + esc(p.at) + '">' + date(p.at) + '</time>' +
      '<a href="' + esc(p.link) + '" target="_blank" rel="noopener">View on Instagram</a>';
    var shop = modal.querySelector('[data-shop]');
    shop.innerHTML = '';
    productsFor(p).then(function (list) {
      if (cur !== i) return;
      if (!list.length) { shop.innerHTML = cfg.fallbackUrl ? '<a class="m-igm__all" href="' + esc(cfg.fallbackUrl) + '">Shop all cases</a>' : ''; return; }
      shop.innerHTML = '<p class="m-igm__shoptitle">Shop this look</p>' + list.map(function (pr) {
        var single = pr.variants && pr.variants.length === 1, v = pr.variants && (pr.variants.find(function (x) { return x.available; }) || pr.variants[0]);
        var cmp = pr.compare_at_price && pr.compare_at_price > pr.price ? '<s>' + money(pr.compare_at_price) + '</s>' : '';
        return '<div class="m-igm__prod">' +
          '<a class="m-igm__pimg" href="' + esc(pr.url) + '">' + (pr.featured_image ? '<img src="' + esc(sized(pr.featured_image, 160)) + '" alt="' + esc(pr.title || '') + '" loading="lazy">' : '') + '</a>' +
          '<div class="m-igm__pinfo"><a class="m-igm__ptitle" href="' + esc(pr.url) + '">' + esc(pr.title) + '</a><span class="m-igm__pprice">' + cmp + money(pr.price) + '</span></div>' +
          (single && v && v.available
            ? '<button type="button" class="m-igm__add" data-add="' + v.id + '">' + esc(cfg.addText || 'Add to bag') + '</button>'
            : '<a class="m-igm__add m-igm__add--ghost" href="' + esc(pr.url) + '">' + esc(cfg.chooseText || 'Choose model') + '</a>') +
        '</div>';
      }).join('');
    });
    modal.querySelectorAll('[data-step]').forEach(function (b) { b.hidden = posts.length < 2; });
  }
  function open(i, from) {
    if (!modal) build();
    lastFocus = from || document.activeElement;
    fill(i);
    modal.hidden = false;
    document.documentElement.classList.add('m-igm-lock');
    void modal.offsetWidth;
    modal.classList.add('is-open');
    modal.querySelector('.m-igm__close').focus({ preventScroll: true });
  }
  function close() {
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('m-igm-lock');
    modal.querySelectorAll('video').forEach(function (v) { v.pause(); });
    setTimeout(function () { if (!modal.classList.contains('is-open')) { modal.hidden = true; modal.querySelector('[data-media]').innerHTML = ''; } }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function step(d) { if (posts.length < 2) return; var n = (cur + d + posts.length) % posts.length; modal.querySelectorAll('video').forEach(function (v) { v.pause(); }); fill(n); }
  function onModalClick(e) {
    if (e.target.closest('[data-close]')) { close(); return; }
    var s = e.target.closest('[data-step]'); if (s) { step(parseInt(s.dataset.step, 10)); return; }
    var sl = e.target.closest('[data-slide]'); if (sl) { showSlide(slide + parseInt(sl.dataset.slide, 10)); return; }
    if (e.target.closest('[data-caption]')) { e.target.closest('[data-caption]').classList.toggle('is-open'); return; }
    var add = e.target.closest('[data-add]'); if (add) addToBag(add);
  }
  // Adds through /cart/add.js (so myntelo-commerce.js logs the add-to-cart event too), then opens the cart drawer.
  function addToBag(btn) {
    if (btn.disabled) return;
    btn.disabled = true; btn.classList.add('is-busy');
    var drawer = document.querySelector('cart-notification');
    fetch(shopRoot + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.add, 10), quantity: 1 }], sections: 'myntelo-cart-drawer,cart-icon-bubble', sections_url: location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.disabled = false; btn.classList.remove('is-busy');
        if (!res.ok || res.j.status) { btn.textContent = res.j.description || 'Sold out'; return; }
        close();
        if (drawer && drawer.renderContents) drawer.renderContents(res.j);
      })
      .catch(function () { btn.disabled = false; btn.classList.remove('is-busy'); });
  }

  /* Load ---------------------------------------------------------------------------------------- */
  function load() {
    fetch(cfg.endpoint, { headers: { apikey: cfg.key, Authorization: 'Bearer ' + cfg.key } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        feed = j;
        if (!j || !j.posts || !j.posts.length) { if (cfg.designMode) { root.hidden = false; grid.innerHTML = '<li class="m-ig__empty">Instagram is not connected yet: add the IG_ACCESS_TOKEN secret in Supabase (project myntelo). Shoppers never see this message.</li>'; } return; }
        profile = j.profile;
        posts = j.posts.filter(function (p) { return p.thumb || p.url || p.children.length; });
        // On a product page, posts of that design come first.
        if (cfg.currentDesign) {
          var mine = posts.filter(function (p) { return designsIn(p.caption).indexOf(cfg.currentDesign) > -1; });
          posts = mine.concat(posts.filter(function (p) { return mine.indexOf(p) < 0; }));
        }
        var h = root.querySelector('[data-m-ig-handle]');
        if (h && profile && profile.username) { h.href = profile.link; if (!h.dataset.custom) h.textContent = '@' + profile.username; }
        root.querySelectorAll('[data-m-ig-follow]').forEach(function (a) { if (profile) a.href = profile.link; });
        render();
      })
      .catch(function () {});
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); } }, { rootMargin: '600px' });
    io.observe(root.parentElement || root);
  } else { load(); }
  if (mobileMQ.addEventListener) mobileMQ.addEventListener('change', function () { if (posts.length) render(); });
})();
